<template>
  <a-card
      size="small"
      style="width:100%"
      :tab-list="tabList"
      :active-tab-key="key"
      @tabChange="key => onTabChange(key)"
  >
    <template slot="tabBarExtraContent">
      <a-select :default-value="rankingType"
                style="width: 100px"
                @change="this.rankingTypeChange">
        <a-select-option value="region">
          大区排行
        </a-select-option>
        <a-select-option value="province">
          省市排行
        </a-select-option>
      </a-select>
    </template>

    <div v-if="key === 'tab1'">
      <div ref="chart" style="width:100%;height:300px"></div>
    </div>
    <div v-else-if="key === 'tab2'">
      <ul class="rankingList">
        <li :key="index" v-for="(item,index) in data">
          <span class="rankingItemNumber">{{index+1}}</span>
          <span class="rankingItemTitle">{{item.name}}</span>
          <span class="rankingItemValue">{{item.value}}</span>
        </li>
      </ul>
    </div>
  </a-card>
</template>

<script>

export default {
  data() {
    return {
      chart: undefined,
      rankingType: 'region',
      key: 'tab1',
      data:[
        { value: 40, name: '华东' },
        { value: 38, name: '华南' },
        { value: 32, name: '华中' },
        { value: 30, name: '华北' },
        { value: 28, name: '西北' },
        { value: 26, name: '西南' },
      ],
      tabList: [
        {
          key: 'tab1',
          tab: '图表',
        },
        {
          key: 'tab2',
          tab: '表格',
        },
      ],
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  mounted() {
    this.initData();
    this.initChart();
  },
  computed:{
    chartOpt(){
      const label = this.rankingType==='region'?'大区':'省市';
      const opt= {
        title: {
          text: `${label}网关数量排行(前6)`,
        },
        tooltip: {
          trigger: 'item',
          formatter: '<br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: [40, 120],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 8
          },
          label: {
            show: false
          },
          data: [...this.data]
          }
        ]
      };
      return opt;
    }
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initData() {

    },
    initChart(){
      this.chart = this.$echarts.init(
          this.$refs.chart
      );
      this.chart.setOption(this.chartOpt, true);
    },
    rankingTypeChange(value) {
      this.rankingType=value;
      if(value==='region'){
        this.data = [
          { value: 40, name: '华东' },
          { value: 38, name: '华南' },
          { value: 32, name: '华中' },
          { value: 30, name: '华北' },
          { value: 28, name: '西北' },
          { value: 26, name: '西南' },
        ];
      }else{
        this.data = [
          { value: 40, name: '江苏' },
          { value: 38, name: '安徽' },
          { value: 32, name: '四川' },
          { value: 30, name: '湖南' },
          { value: 28, name: '北京' },
          { value: 26, name: '广州' },
        ];
      }
      this.initChart();
    },
    onTabChange(key) {

      this.key = key;
      this.$nextTick(()=>{
        if (key==='tab1'){
          this.initChart();
        }
      });
    }
  },
};

</script>

<style scoped lang="less">

.ant-card {
  background-color: rgba(255,255,255,0.5);
}

.rankingList {
  margin: 25px 10px 0px 10px ;
  padding: 0;
  list-style: none;
  li {
    margin-top: 16px;
    display: flex;
    align-items: center;
    span {
      color: #001d20;
      font-size: 14px;
      line-height: 22px;
    }
    .rankingItemNumber {
      background-color: #ffffff;
      border-radius: 20px;
      display: inline-block;
      font-size: 12px;
      font-weight: 600;
      margin-right: 16px;
      height: 20px;
      line-height: 20px;
      width: 20px;
      text-align: center;
      margin-top: 1.5px;
      &.active {
        background-color: #314659;
        color: #fff;
      }
    }
    .rankingItemTitle {
      flex: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 8px;
    }
  }
}
</style>
